import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { KeyRound, Globe } from "lucide-react";
import { LANGUAGE_OPTIONS } from "../../translations/dealerPortal";
import { PasswordInput } from "../shared/PasswordInput";
import { TelcaVoIPBadge } from "../shared/TelcaVoIPBadge";
import { LOJACK_LOGO } from "../../config";

const DealerLogin = ({ loginData, setLoginData, loginError, handleLogin, lang, changeLang, t }) => (
  <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4">
    <div className="w-full max-w-md">
      <div className="text-center mb-8">
        <div className="flex flex-col items-center justify-center gap-3 mb-4">
          <img src={LOJACK_LOGO} alt="LoJack Tracker" className="h-12" data-testid="dealer-login-logo" />
          <img src="/securewallet_logo_white.webp" alt="Secure Wallet" className="h-7" data-testid="dealer-login-securewallet-logo" />
        </div>
        <h1 className="text-xl font-semibold text-white" data-testid="dealer-login-title">{t.portalTitle}</h1>
        <p className="text-gray-500 text-sm mt-1">{t.loginSubtitle}</p>
      </div>
      <form onSubmit={handleLogin} className="wallet-card space-y-4">
        {loginError && <div className="bg-red-900/20 border border-red-800 rounded-lg p-3 text-red-400 text-sm">{loginError}</div>}
        <div><label className="text-gray-400 text-sm">{t.email}</label><input type="email" value={loginData.email} onChange={e => setLoginData({...loginData, email: e.target.value})} className="w-full mt-1 px-4 py-3 bg-[#111] border border-gray-700 rounded-xl text-white focus:border-lojack-red focus:outline-none" required data-testid="dealer-login-email" /></div>
        <div><label className="text-gray-400 text-sm">{t.password}</label><PasswordInput value={loginData.password} onChange={e => setLoginData({...loginData, password: e.target.value})} className="w-full mt-1 px-4 py-3 pr-12 bg-[#111] border border-gray-700 rounded-xl text-white focus:border-lojack-red focus:outline-none" required data-testid="dealer-login-password" /></div>
        <button type="submit" className="btn-lojack w-full" data-testid="dealer-login-submit">{t.login}</button>
        <div className="text-center pt-1">
          <Link to="/dealer/forgot-password" className="text-gray-500 hover:text-lojack-red text-sm transition-colors" data-testid="dealer-forgot-password-link">
            <KeyRound size={13} className="inline mr-1" />{t.forgotPassword}
          </Link>
        </div>
      </form>
      <div className="flex items-center justify-center gap-2 mt-4">
        <Globe size={14} className="text-gray-600" />
        <select value={lang} onChange={e => changeLang(e.target.value)}
          className="bg-transparent text-gray-500 text-xs border border-gray-800 rounded-lg px-2 py-1 focus:outline-none focus:border-lojack-red cursor-pointer"
          data-testid="login-lang-selector">
          {LANGUAGE_OPTIONS.map(l => <option key={l.code} value={l.code} style={{backgroundColor:'#111'}}>{l.label}</option>)}
        </select>
      </div>
      <div className="text-center mt-6"><TelcaVoIPBadge /></div>
    </div>
  </div>
);

export default DealerLogin;

DealerLogin.propTypes = {
  loginData: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  setLoginData: PropTypes.func.isRequired,
  loginError: PropTypes.string,
  handleLogin: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  changeLang: PropTypes.func.isRequired,
  t: PropTypes.object.isRequired,
};
